import { Button, Center, Divider, Grid, Heading, Icon, Image, List, ListItem, Spinner, Stack, Text } from '@chakra-ui/react'
import { faCheckCircle, faCircleXmark } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ResetPasswordForm, ResetPasswordUserInfo, SendResetPasswordLinkForm } from 'brokertslib/src/containers'
import { useGetResetPasswordInfo } from 'BrokerTsLib/src/hooks'
import { useMemo, useState } from 'react'
import { Link, useSearchParams } from 'react-router'

import { Card, CardBody } from '@/components/Card'
import { Container } from '@/components/Container'
import { Section } from '@/components/Section'

import okAppkyLogo from '../../assets/images/logo-ok-appky.svg'

export const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams()
  const userId = searchParams.get('userId') ?? undefined
  const token = searchParams.get('token') ?? undefined
  const isNewUser = !!searchParams.get('isNewUser')

  const { info, isLoading, isError, passwordRules } = useGetResetPasswordInfo(userId, token)

  const [isFinished, setIsFinished] = useState(false)

  const state = useMemo(() => {
    if (!userId || !token) return 'request'

    if (isLoading) return 'loading'

    if (isError) return 'error'

    if (isFinished) return 'finished'

    return 'reset'
  }, [userId, token, isLoading, isError, isFinished])

  return <Section variant="login">
    <Container>
      <Grid sx={{ maxW: 'loginFormMaxW', m: 'auto', gap: 8, alignContent: 'start' }}>
        <Image src={okAppkyLogo} w={'auto'} maxW="14rem" h={12} m="auto" alt="OK appky" />

        <Card>
          <CardBody>
            <Stack>
              <Heading as="h2" size="md">
                {isNewUser ? 'Nastavení hesla' : state === 'request' ? 'Obnovit heslo' : 'Změna hesla'}
              </Heading>

              {state === 'loading' &&
                                <Stack alignItems='center' gap={8} mt={6}>
                                  <Spinner size='lg' speed="0.7s" />
                                  <Heading fontSize='xl' fontWeight='medium'>
                                    Načítání informací...
                                  </Heading>
                                </Stack>
              }

              {state === 'reset' &&
                                <Stack h='full' gap={4} mt={2}>
                                  <ResetPasswordUserInfo bg='gray.100' borderRadius='md' {...info!} />
                                  <Stack>
                                    <Heading as="h3" size="md" color="primary.700">
                                      Pravidla pro heslo
                                    </Heading>
                                    <List variant="textMuted" fontSize="sm" listStyleType='disc' pl={4} id="password-constraints">
                                      {passwordRules.map(x => <ListItem key={x.key}>{x.name}</ListItem>)}
                                    </List>
                                  </Stack>
                                  <ResetPasswordForm mt='auto' isNewUser={isNewUser} userId={userId!} token={token!} info={info!} onPasswordReset={() => setIsFinished(true)} />
                                </Stack>
              }


              {state === 'finished' &&
                                <Stack h='full' gap={6}>
                                  <Center flexGrow={1} as={Stack} py={{ base: 4, md: 6 }} gap={{ base: 4, md: 6 }}>
                                    <Icon as={FontAwesomeIcon} icon={faCheckCircle} color='green.600' size='2x' />
                                    <Heading as="h1" size="lg" color="green.700">
                                      {isNewUser ? 'Heslo nastaveno' : 'Heslo změněno'}
                                    </Heading>
                                    <Text variant="textMuted" fontSize="sm">
                                      Vaše heslo bylo úspěšně nastaveno. Nyní se můžete přihlásit a&nbsp;začít používat aplikaci.
                                    </Text>
                                  </Center>
                                  <Button w='full' as={Link} to='/' size='lg'>Přejít na přihlášení</Button>
                                </Stack>
              }

              {state === 'error' &&
                                <Stack h='full' gap={6}>
                                  <Center flexGrow={1} as={Stack} pt={{ base: 4, md: 6 }} gap={{ base: 4, md: 6 }}>
                                    <Icon as={FontAwesomeIcon} icon={faCircleXmark} color='red.700' size='2x' />
                                    <Heading as="h1" size="lg" color="red.700">
                                      Odkaz je neplatný
                                    </Heading>
                                    <Text variant="textMuted" fontSize="sm">
                                      Váš odkaz pro {isNewUser ? 'nastavení hesla' : 'změnu hesla'} není platný nebo vypršel. Požádejte si o&nbsp;nový odkaz a&nbsp;zkuste to znovu. Pokud problém přetrvává, kontaktujte podporu.
                                    </Text>
                                  </Center>
                                  <Divider />
                                  <SendResetPasswordLinkForm mt='auto' w='full' />
                                </Stack>
              }

              {state === 'request' &&
                                <Stack h='full' gap={6}>
                                  <Text variant="textMuted" fontSize="sm">
                                    Pro obnovu hesla prosím zadejte vaše uživatelské jméno. Na Váš e-mail zašleme
                                    odkaz s návodem na obnovu hesla.
                                  </Text>
                                  <SendResetPasswordLinkForm mt='auto' w='full' />
                                </Stack>
              }

            </Stack>
          </CardBody>
        </Card>
      </Grid>
    </Container>
  </Section>
}

